import ReactDOM from "react-dom/client";
import "./index.css";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import Home from "./pages/Home/Home";
import Camion from "./pages/Logisitiques/Camion/Camion";
import Chauffeur from "./pages/Logisitiques/Chauffeur/Chauffeur";
import Trajet from "./pages/Logisitiques/Trajet/Trajet";
import Entretien from "./pages/Logisitiques/Entretien/Entretien";
import Utility from "./pages/Utility/Utility";
import MapsCamions from "./pages/Logisitiques/Camion/MapsCamions";
import Clients from "./pages/Commerciale/Clients";
import Dotations from "./pages/Commerciale/Dotations";
// Commerciale
// import Clients from "./pages/Commerciale/Clients";
// import Factures from "./pages/Commerciale/Factures";
import Devis from "./pages/Commerciale/Devis";
import Login from "./pages/Login/Login";
import Provision from "./pages/Transit/Provision";
import Factures from "./pages/Commerciale/Factures";
import Commandes from "./pages/Commerciale/Commandes";
import MobileUpload, { MobileLogin } from "./composants/mobile/UploadBC";
import UploadImage from "./composants/mobile/UploadImage";
import MobileLayout from "./composants/mobile_layout/MobileLayout";
import Inventaire from "./pages/Logisitiques/Inventaires/Inventaire";
import ProspectionsList from "./pages/Commerciale/Prospections";
import Acceuil from "./pages/Home/Acceuil";
import Task from "./pages/Transit/Task";
import Dossier from "./pages/Transit/Dossier";
import DevisTransit from "./pages/Transit/DevisTransit";
import FactureTransit from "./pages/Transit/FactureTransit";
import Echeances from "./pages/Commerciale/Echeances";
import Dasboard from "./pages/Dashboard/Dashboard";
import '../src/assets/css/caisse-interne.css';
import CaissePreview from "./pages/Finance/CaissePreview";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />

      <Route path="/mobile" element={<MobileLayout />}>
        <Route path="login" element={<MobileLogin />} />
        <Route path="upload" element={<UploadImage />} />
      </Route>

      <Route path="/acceuil" element={<Home />}>
        <Route index element={<Acceuil />} />
      </Route>


      {/* Section Logistique */}
      <Route path="/logistique" element={<Home />}>
        <Route path="camion" element={<Camion />} />
        <Route path="mtec" element={<MapsCamions />} />
        <Route path="chauffeur" element={<Chauffeur />} />
        <Route path="trajet" element={<Trajet />} />
        <Route path="entretien" element={<Entretien />} />
        <Route path="inventaires" element={<Inventaire />} />
        <Route path="commandes" element={<Commandes />} />
      </Route>

      {/* Section Commerciale */}
      <Route path="/commerciale" element={<Home />}>
        <Route path="clients" element={<Clients />} />
        <Route path="prospection" element={<ProspectionsList />} />
        <Route path="dotations" element={<Dotations />} />
        <Route path="devis" element={<Devis />} />
        <Route path="facture" element={<Factures />} />
        <Route path="echeance" element={<Echeances />} />

      </Route>

      {/* Section Transit */}
      <Route path="/transit" element={<Home />}>
        <Route path="provision" element={<Provision />} />
        <Route path="task" element={<Task />} />
        <Route path="dossier" element={<Dossier />} />
        <Route path="devis" element={<DevisTransit />} />
        <Route path="facture" element={<FactureTransit />} />
      </Route>

      {/* Section Sezttings */}
      <Route path="/settings" element={<Home />}>
        <Route path="utilitaires" element={<Utility />} />
      </Route>

      {/* Section Finance */}
      <Route path="/finance" element={<Home />}>
        <Route path="interne" element={<CaissePreview />} />
      </Route>


      {/* Section Dashboard */}
      <Route path="/dashboard" element={<Home />}>
        <Route index element={<Dasboard />} />
      </Route>

      {/* Redirection par défaut */}
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/logistique/camion" replace />} />
    </Routes>
  </BrowserRouter>
);
